
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing/quote/result",
      function () {
        return require("private-next-pages/pricing/quote/result/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pricing/quote/result"])
      });
    }
  